import { Form } from "formik";
import { isObject } from "lodash";
import React from "react";

import Button from "../../UI/Button";
import { CustomForm } from "../../../component-library/CustomForm";
import FormikInput from "../../UI/FormikInput";

const AdmitPatientPopup = (props) => {
  const { admitPatient, fullName, hidePopup } = props;

  let displayName = fullName;

  if (isObject(fullName)) {
    displayName = `${fullName.f_name} ${fullName.l_name}`;
  }

  let renderForm = (formikProps) => {
    return (
      <Form>
        <div className="PatientStatusPopUp__btn-wpr d-flex pt-3 my-4 tw:justify-center">
          <Button className="Btn Btn--otl-pri Btn-sm mx-2" onClick={hidePopup} type="button">
            Cancel
          </Button>
          <Button className="Btn Btn--pri Btn-sm mx-2" type="submit">
            Yes Admit
          </Button>
        </div>
        <FormikInput
          errors={formikProps.errors}
          formEl={{
            elementConfig: {
              label: "Note",
              placeholder: "Note",
              type: "textarea",
            },
            elementType: "textarea",
            name: "note",
          }}
          touched={formikProps.touched}
        />
      </Form>
    );
  };

  return (
    <div className="admitPatientPopUp position-fixed d-flex align-items-center tw:justify-center">
      <div className="PatientStatusPopUp__inner d-flex flex-column text-center position-absolute px-4">
        <h2 className="fs-17 mt-4 tw:font-bold">Admit to 90 Day Care</h2>
        <span className="fs-15 mt-2">
          Are you sure you want to admit{" "}
          <span className="mt-1 pt-1 tw:font-bold" data-private>
            {displayName}
          </span>{" "}
          in 90 day care program?{" "}
        </span>
        <CustomForm initialValues={{}} onSubmit={admitPatient} render={renderForm} />
      </div>
    </div>
  );
};

export default AdmitPatientPopup;
